import Service from './service';

class Posts extends Service {
  constructor(baseUrl, request) {
    super(baseUrl, request);
    this.url = `${this.baseUrl}/posts`;
  }

  /**
   * @see https://developer.wordpress.org/rest-api/reference/posts/
   */
  list(params) {
    return this.get(this.url, params);
  }
}

export default Posts;



// WEBPACK FOOTER //
// ./src/helpers/wp-api/posts.js